import http from '@/api/http';

export default {
  // 检测 邮件主题是否敏感
  onDetectSubject(data: Record<any, any>) {
    return http.post(`/sensitive/check`, data, {
      params: { switchReqToUnderline: true },
    });
  },
}
